<div class="action-modal">
  <!-- HEADER -->
  <div class="modal-head">
    <span class="modal-head-icon"><mat-icon>credit_card</mat-icon></span>
    <div class="modal-head-text">
      <h1>Recharge customer</h1>
      <p class="modal-subtitle">
        @if (data.transaction.crossReference) {
          Ref {{ data.transaction.crossReference }}
        } @else {
          Charge the card on file again
        }
      </p>
    </div>
    <button
      mat-icon-button
      class="modal-head-close"
      (click)="cancel()"
      aria-label="Close"
      data-test="tx-recharge-transaction-cancel-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- BODY -->
  @if (rechargeForm) {
    <div class="modal-body">
      <!-- Original transaction summary -->
      <section class="modal-section">
        <p class="section-label">Card on file</p>
        <div class="summary" data-test="tx-recharge-summary">
          @if (data.transaction.maskedCard || data.transaction.last4Digits) {
            <div class="kv-row">
              <span class="kv-k">Card</span>
              <span class="kv-v">
                {{ data.transaction.maskedCard || '•••• ' + data.transaction.last4Digits }}
              </span>
            </div>
          }
          @if (data.transaction.cardHolderDetails?.name) {
            <div class="kv-row">
              <span class="kv-k">Customer</span>
              <span class="kv-v">{{ data.transaction.cardHolderDetails.name }}</span>
            </div>
          }
          <div class="kv-row">
            <span class="kv-k">Original</span>
            <span class="kv-v">
              {{ data.transaction.amount | currency: currencyAlphaCode }}
              @if (data.transaction.createdOn) {
                <span class="text-muted"> on {{ data.transaction.createdOn | date: 'd MMM y' }}</span>
              }
            </span>
          </div>
        </div>
      </section>

      <!-- Account to charge on -->
      <section class="modal-section">
        <p class="section-label">Charge to</p>
        <odin-account-selector
          [transaction]="data.transaction"
          label="Merchant account"
          testPrefix="tx-recharge"
          (selectionChange)="onAccountSelected($event)"
        ></odin-account-selector>
      </section>

      <!-- Charge details -->
      <section class="modal-section">
        <p class="section-label">Charge details</p>
        <odin-dynamic-form [formData]="rechargeForm"></odin-dynamic-form>
        <div class="modal-note">
          <mat-icon>info_outline</mat-icon>
          <span>
            The customer is charged immediately on completion. If the charge is
            declined, the card may have been removed from file.
          </span>
        </div>
      </section>
    </div>
  }

  <odin-loading-spinner [active]="processing" [overlay]="true"></odin-loading-spinner>
</div>
